<script setup lang="ts">
import { ChipButton } from '../chip/'
import { IconPlus, IconMinus, IconCross } from '@caks/uikit/icon/'
import { onMounted, shallowRef, computed } from 'vue'
import { CartItem } from '@caks/shared/types/types.user'
import { useAccountStore } from '@caks/shared/store/store.account'

interface Props {
  order?: boolean
  food: CartItem
  mobile?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  order: false,
})

const emit = defineEmits<{
  (e: 'change-count', id: number, type: 'increase' | 'decrease'): void
  (e: 'remove', id: number): void
}>()

const description = shallowRef<string>('')
const store = useAccountStore()

const price = computed(() => `${props.food.amount * props.food.cost || props.food.cost_per_item}₽`)

onMounted(() => {
  if (!props.order) {
    let tempString = ''
    let base = props.food.item.available_modifications.base_modifications
    for (let i = 0; i < base.length; i++) {
      tempString += base[i].name + ', '
    }
    let imgredients = props.food.item.available_modifications.ingredients
    for (let i = 0; i < imgredients.length; i++) {
      tempString += imgredients[i].name + ', '
    }
    description.value = tempString[0] + tempString.slice(1, tempString.length - 2).toLowerCase()
  } else {
    let tempString = ''

    let base = props.food.item.base_modifications
    for (let i = 0; i < base.length; i++) {
      tempString += base[i].name + ', '
    }

    let imgredients = props.food.item.ingredients
    for (let i = 0; i < imgredients.length; i++) {
      tempString += imgredients[i].name + ', '
    }

    description.value = tempString[0] + tempString.slice(1, tempString.length - 2).toLowerCase()
  }
})

const increaseCount = () => {
  console.log('increaseCount')

  emit('change-count', props.food.id, 'increase')
}

const decreaseCount = () => {
  console.log('decreaseCount')

  emit('change-count', props.food.id, 'decrease')
}
</script>

<template>
  <div>
    <article class="food" :class="{ mobile }" @click="$router.push(`/food/${food.item.id}`)">
      <div class="food__image">
        <img :src="food.item.main_media" :alt="food.item.name" />
      </div>

      <div class="food__info">
        <div class="food__header">
          <h3 class="food__title" v-text="food.item.name" />
          <div v-if="!order" @click.stop="emit('remove', food.id)" class="food__close">
            <icon-cross />
          </div>
        </div>
        <p class="food__description">{{ food.item.description }}</p>
        <ul class="food__modifications">
          <li v-for="item in food.extraModificators" :key="item.id">
            <p>{{ item.name }}</p>
          </li>
        </ul>
        <ul class="food__modifications">
          <li v-for="item in food.baseModificators">
            <p>{{ item.name }}: {{ item.variant_name }}</p>
          </li>
        </ul>
        <ul class="food__modifications food__modifications_removed">
          <li v-for="item in food.removedModificators" :key="item.id">
            <p>{{ item.name }}</p>
          </li>
        </ul>
        <div class="food__price-wrap">
          <ChipButton v-if="!order" secondary>
            <template v-slot:start><icon-minus @click.stop="decreaseCount" /></template>
            <template v-slot:default>{{ food.amount }}</template>
            <template v-slot:end><icon-plus @click.stop="increaseCount" /></template>
          </ChipButton>

          <div class="food__price" v-text="price" />
        </div>
      </div>
    </article>
  </div>
</template>

<style scoped lang="scss">
.food {
  display: flex;
  padding: 8px 0;
  gap: 16px;

  &__image {
    height: 116px;
    width: 116px;
    min-width: 116px;
    border-radius: 16px;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  &__info {
    width: 100%;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    --svg-col: #{$sub-text};
  }

  &__title {
    @include h4-2;
    color: $primary-text;
  }

  &__description {
    @include h7-1;
    margin: 12px 0 0;
    color: $sub-text;
  }

  &__modifications {
    @include h7-1;
    margin: 2px 0 0;
    color: $primary-green;

    &_removed {
      color: $primary-red;
      margin: 2px 0 12px;
    }
  }

  &__price-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__price {
    @include h5-6;
    color: $primary-green;
  }
}
</style>
